export default __webpack_public_path__ + "static/media/colorectal_plot_male.1cef3059.png";